import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "kreuse_admin_token";

export function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

/** Generic admin GET hook with refresh and 401 handling. */
export function useAdminList(token, path, onUnauthorized) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}${path}`, { headers: authHeaders(token) });
      setData(res.data);
    } catch (err) {
      if (err?.response?.status === 401 && onUnauthorized) onUnauthorized();
    } finally {
      setLoading(false);
    }
  }, [token, path, onUnauthorized]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, refresh, setData };
}

export async function downloadCsv(token, path, filename) {
  const res = await axios.get(`${API}${path}`, {
    headers: authHeaders(token),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
